export async function questLoader({ params }) {
  const questData = { quest: params.questId };
  return { questData };
}

export async function userLoader({ params }) {
  const userData = { user: params.userId };
  return { userData };
}
